module.exports = __webpack_public_path__ + "img/image-8.5eea147f.webp";